var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed } from '@ember/object';
import Service, { inject as service } from '@ember/service';
import moment from 'moment';
let WeekdaysService = (_dec = computed('intl'), _class = class WeekdaysService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  get weekdayName() {
    return new Map([[1, this.intl.t('weekdaySelections.monday')], [2, this.intl.t('weekdaySelections.tuesday')], [3, this.intl.t('weekdaySelections.wednesday')], [4, this.intl.t('weekdaySelections.thursday')], [5, this.intl.t('weekdaySelections.friday')], [6, this.intl.t('weekdaySelections.saturday')], [7, this.intl.t('weekdaySelections.sunday')]]);
  }

  // ISO ordinals: 1 = Monday, 2 = Tuesday, ... 7 = Sunday
  getIsoOrdinal(dayOfWeek) {
    if (typeof dayOfWeek === 'number') {
      // Some places (moment) uses 0 = Sunday, so we force it to be 7
      return dayOfWeek || 7;
    }
    const search = dayOfWeek.toLocaleLowerCase().slice(0, 3);
    const found = ['SKIP',
    // Eats the 0 index
    'mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].indexOf(search);
    return found < 0 ? null : found;
  }
  getWeekdayShortName(dayOfWeek) {
    const ordinal = this.getIsoOrdinal(dayOfWeek) || 0;
    return moment.weekdaysShort(ordinal % 7);
  }
  getWeekdayName(dayOfWeek) {
    return this.weekdayName.get(this.getIsoOrdinal(dayOfWeek));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "weekdayName", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "weekdayName"), _class.prototype), _class);
export { WeekdaysService as default };